import {Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {group} from "@angular/animations";
import {ModalController} from "@ionic/angular";
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ClientRequestForm} from "../../../../types/interfaces";
import {PreloaderService} from "../../../../services/preloader/preloader.service";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";
import {ParentService} from "../../../../services/mygreencountry/parent.service";
import {AuthService} from "../../../../services/mygreencountry/auth.service";
import {CONTACT_WAYS, PARENT_REQUEST_CRM_TEXTS, STUDENT_REQUEST_CRM_TEXTS} from "../../../constants";
import {PersistenceService} from "../../../../services/mygreencountry/persistence.service";

@Component({
    selector: 'app-student-request',
    templateUrl: './student-request.component.html',
    styleUrls: ['./student-request.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class StudentRequestComponent implements OnInit {
    requestForm: FormGroup;
    activeChild$ = this.parentService.getActiveChild();

    @Input() type: string = '';
    @ViewChild('telInputBlock') telInputBlock: ElementRef<HTMLInputElement>;

    public contactPhone: string = '';
    public childPhone: string = '';
    public requestSuccess: boolean = false;
    public isParent: boolean = false;
    public isParentRole: boolean = false;

    public PARENT_REQUEST_CRM_TEXTS = PARENT_REQUEST_CRM_TEXTS;
    public STUDENT_REQUEST_CRM_TEXTS = STUDENT_REQUEST_CRM_TEXTS;
    public CONTACT_WAYS = CONTACT_WAYS;


    constructor(
        private modalCtrl: ModalController,
        private fBuilder: FormBuilder,
        private preloaderService: PreloaderService,
        public myGcService: MyGreenCountry,
        private parentService: ParentService,
        private authService: AuthService,
        private persistenceService: PersistenceService,
    ) {
        this.activeChild$.subscribe({
            next: (child) => {
                if (child) {
                    this.childPhone = child?.phone;
                }else{
                    this.childPhone = this.persistenceService.get('activeChildPhone') as string;
                }
            }
        })


    }


    ngOnInit() {

        this.isParent = this.authService.isParent();
        this.isParentRole = this.authService.isParentRole();

        this.requestForm = this.fBuilder.group({
            contactName: ['', [Validators.required, Validators.maxLength(255)]],
            contactPhone: new FormControl('', [Validators.required, Validators.maxLength(255)]),
            childPhone: new FormControl('', [Validators.required, Validators.maxLength(255)]),
            contacts: new FormArray([]),
            // text: this.type === 'changedGroup' ? this.changeGroupRequest :  this.type === 'continueTest' ? this.changeGroupRequest :this.continueStudyRequest
            text: this.getTextByType()
        });


    }


    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    getTextByType(): string | undefined {
        let item = this.STUDENT_REQUEST_CRM_TEXTS.find(entry => entry.type === this.type);

        if (this.isParent && this.isParentRole) {
            item = this.PARENT_REQUEST_CRM_TEXTS.find(entry => entry.type === this.type);
        }

        return item ? item.text : undefined;
    }

    onSubmit(): void {
        this.requestForm.controls['contactPhone'].setValue(this.contactPhone)
        this.requestForm.controls['childPhone'].setValue(this.childPhone)

        if (this.requestForm.valid) {
            this.sendRequest(this.requestForm.value).then(() => {
                console.log('success');
            });
        } else {
            Object.keys(this.requestForm.controls).forEach(controlName => {
                const control = this.requestForm.get(controlName);
                if (control && control.invalid) {
                    console.log(`${controlName} is invalid. Errors:`, control.errors);
                }
            });
        }
    }

    onCheckChange(event: any) {
        const formArray: FormArray = this.requestForm.get('contacts') as FormArray;

        if (event.target.checked) {
            formArray.push(new FormControl(event.target.value));
        } else {
            let i: number = 0;
            // @ts-ignore
            formArray.controls.forEach((ctrl: FormControl) => {
                if (ctrl.value == event.target.value) {
                    formArray.removeAt(i);
                    return;
                }

                i++;
            });
        }
    }


    async sendRequest(form: ClientRequestForm, redirect: boolean = false, urlRedirect = '') {

        // this.preloaderService.showLoading("please wait... ");

        this.myGcService.sendClientRequest(form)

            .subscribe({

                next: (response) => {
                    if (response.success) {
                        this.requestSuccess = true;
                    }

                },

                error: (error) => {

                    //@TODO: show error message
                    console.log('error', error)

                },

                complete: () => {

                    this.preloaderService.hideLoading();

                }

            })

        console.log(form);
    }
}
